(() => {
  const SELECTOR = '[data-bd-footer-reveal]';
  const TOTAL_DURATION = 0.7 + 13 * 0.15;

  function init(root) {
    if (!root || root.dataset.bdFooterRevealReady === 'true') return;
    root.dataset.bdFooterRevealReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let observer = null;
    let completionTimer = 0;

    function play() {
      if (root.classList.contains('is-playing') || root.classList.contains('is-complete')) return;
      if (reducedMotion.matches) {
        root.classList.add('is-complete');
        return;
      }
      root.classList.add('is-playing');
      completionTimer = window.setTimeout(() => {
        root.classList.remove('is-playing');
        root.classList.add('is-complete');
      }, TOTAL_DURATION * 1000 + 100);
    }

    observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) return;
      play();
      observer.disconnect();
    }, { threshold: [0.5] });
    observer.observe(root);

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target?.contains(root)) return;
      observer?.disconnect();
      window.clearTimeout(completionTimer);
    }, { once: true });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
